module.exports = __webpack_public_path__ + "static/scale-model-of-fort-monroe-national-monument-in-hampton-virginia-25d3565cbd2368b3da84850172a826f0.png";